<template>
  <t-default-layout active-nav-id="news-and-seminars">
    <div :class="componentClassName">
      <a-back-page :id="id" :text="backPageName()" :page="backPage()" :show="show" />
      <form
        ref="form"
        class="t-news-and-seminars-edit__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-news-and-seminars-edit__fields">
          <m-section>
            <m-action-card
              :id="idName[1]"
              test-id-text="edit-news-and-seminar"
              title="詳細設定"
              :document-id="id"
              header-border
              no-header-margin
              icon="clock"
            >
              <div class="t-news-and-seminars-edit__fields">
                <div class="t-news-and-seminars-edit__row">
                  <m-form-input id="t-news-and-seminars-edit-importantFlag__form-input">
                    <a-text id="t-news-and-seminars-edit-importantFlag__a-text">優先</a-text>
                    <a-switch
                      id="t-news-and-seminars-edit-importantFlag"
                      v-model="newsAndSeminarData.importantFlag"
                      data-testid="edit-news-and-seminar-priority-toggle"
                    />
                  </m-form-input>
                </div>
                <o-transition-type-selector
                  v-if="updatedDataFlag"
                  v-model:transition-type="newsAndSeminarData.transitionType"
                  v-model:transition-doc="newsAndSeminarData.transitionDoc"
                  v-model:contents-url="newsAndSeminarData.contentsURL"
                />
                <div id="t-news-and-seminars-edit-radio" class="t-news-and-seminars-edit__row">
                  <m-form-input>
                    <m-news-and-seminar
                      id="radio-news"
                      v-model="newsAndSeminarData.type"
                      data-testid="edit-news-and-seminar-select-news"
                      name="flag"
                      value="news"
                      label="ニュース"
                    />
                    <m-news-and-seminar
                      id="radio-seminar"
                      v-model="newsAndSeminarData.type"
                      data-testid="edit-news-and-seminar-select-seminar"
                      name="flag"
                      value="seminar"
                      label="セミナー"
                    />
                  </m-form-input>
                </div>
                <div id="t-news-and-seminars-edit-uploading-file" class="t-news-and-seminars-edit__row">
                  <div class="t-news-and-seminars-edit__col-1">
                    <div class="t-news-and-seminars-edit__fields">
                      <!-- .jfifと.svg対応はチケット#6297で対応予定 -->
                      <!-- <m-form-input>
                        <a-upload-field
                          id="upload-image"
                          v-model="newsAndSeminarData.imageFile.file"
                          name="imageFile"
                          class="t-news-and-seminars-edit-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, .jfif, image/jpg, image/jpeg, .svg"
                          @change="handleUploadFileChange('imageFile', newsAndSeminarData.imageFile.file)"
                          @showErrorModal="showErrorModal"
                        />
                      </m-form-input> -->
                      <m-form-input>
                        <a-upload-field
                          id="upload-image"
                          v-model="newsAndSeminarData.imageFile.file"
                          test-id-text="edit-news-and-seminar-image"
                          name="imageFile"
                          class="t-news-and-seminars-edit-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, image/jpg, image/jpeg"
                          @change="handleUploadFileChange('imageFile', newsAndSeminarData.imageFile.file)"
                          @show-error-modal="showErrorModal"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-news-and-seminars-edit__col-2">
                    <div class="t-news-and-seminars-edit__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="title"
                          v-model="newsAndSeminarData.title"
                          data-testid="edit-news-and-seminar-title-input"
                          type="text"
                          maxlength="30"
                          maxlength-id="edit-news-and-seminar-title-maxlength"
                          placeholder="タイトル入力"
                        />
                      </m-form-input>
                    </div>
                  </div>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-news-and-seminars-edit__fields">
                <div id="t-news-and-seminars-edit-cast-start-date-day__row" class="t-news-and-seminars-edit__row">
                  <a-text id="t-news-and-seminars-edit-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-news-and-seminars-edit-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="newsAndSeminarData.castStartDate"
                      test-id-text="edit-news-and-seminar-publish-start"
                      :min-date="minDate"
                      date-placeholder="公開日"
                      time-placeholder="00:00"
                      mode="dateTime"
                      :disabled="hasParentDoc"
                    />
                  </m-form-input>
                </div>
                <div class="t-news-and-seminars-edit__row">
                  <a-text id="t-news-and-seminars-edit-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-news-and-seminars-edit-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="newsAndSeminarData.castEndDate"
                      test-id-text="edit-news-and-seminar-publish-end"
                      :min-date="minDate"
                      date-placeholder="公開終了日"
                      time-placeholder="00:00"
                      mode="dateTime"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-news-and-seminars-edit__fields__pushtype">
                <m-form-input id="t-news-and-seminars-edit__fields__pushtype">
                  <a-select-field
                    id="t-news-and-seminar-edit__fields__pushtype__a-select-field"
                    v-model="newsAndSeminarData.checkStatus"
                    data-testid="detail-news-and-seminar-check-status-select"
                    :options="checkStatusOptions"
                    :v-options="visibleCheckStatusOptions"
                  />
                </m-form-input>
              </div>
              <!-- 情報を表示するために m-data-table を追加します 承認フロー -->
              <m-data-table
                :empty-text="dataTableEmp"
                :fit="true"
                :data="newsAndSeminarData.checkHistories"
                id-text="news-and-seminar-check-histories-info-display"
              >
                <a-data-table-column
                  prop="publishedDocumentId"
                  :min-width="120"
                  :label="'公開ドキュメントID：<br>' + docId"
                  align="center"
                >
                  <template #default="scope">
                    <a-text size="medium" :center="true">公開{{ scope.index + 1 }}回目</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="draft" :min-width="100" label="下書き" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.draft.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.draft.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="checked" :min-width="100" label="チェック済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.checked.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.checked.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="approved" :min-width="100" label="承認済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.approved.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.approved.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
              </m-data-table>
            </m-action-card>
          </m-section>
        </div>
        <m-form-action-buttons>
          <a-button
            id="saveBtn"
            data-testid="edit-news-and-seminar-save-button"
            variant="block"
            color="primary"
            submit="submit"
            >保存</a-button
          >
        </m-form-action-buttons>
      </form>
    </div>

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="news-and-seminarsCreate_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="news-and-seminarsCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            data-testid="error-info-modal-confirm-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MNewsAndSeminar from '@/components/molecules/news-and-seminar-radio';
import OTransitionTypeSelector from '@/components/organisms/transition-type-selector';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';
import { useVuelidate } from '@vuelidate/core';
import { newsAndSeminarValidation } from '@/validations/newsAndSeminar.js';
import { cloneDeep } from 'lodash';

export default {
  name: 't-news-and-seminars-edit',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    ASwitch,
    AUploadField,
    ACalendarField,
    MNewsAndSeminar,
    AApplyTextField,
    OTransitionTypeSelector,
  },
  mixins: [customRequest, customValidate, messageContent, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      id: this.$route.query.id,
      source: this.$route.query.source,
      show: this.$route.query.show ?? '1',
      idName: [],
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      hasParentDoc: false,
      docId: (() => {
        const id = this.$route.query.id;
        if (id.includes('_')) {
          const lastIndex = id.lastIndexOf('_');
          return id.slice(0, lastIndex);
        }
        return id;
      })(),

      //おすすめの記事・セミナーデータ
      newsAndSeminarData: {
        title: '', //おすすめの記事・セミナータイトル
        imageURL: '', //
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        importantFlag: false, //優先フラグ
        castStartDate: '', //公開開始日
        castEndDate: '', //公開終了日
        deleteDate: '', //削除予定日
        draftFlag: false, //下書き
        checkStatus: 'draft', //チェックステータス
        type: '',
        contentsURL: '',
        checkHistories: [
          {
            draft: {
              userName: '',
              updateDate: '',
            },
            checked: {
              userName: '',
              updateDate: '',
            },
            approved: {
              userName: '',
              updateDate: '',
            },
          },
        ],
        transitionType: 'url', //遷移先種別
        transitionDoc: '', //遷移先ドキュメントID
      },
      isPublished: false, //公開中かどうかのフラグ
      beforeCastEndDate: '', //変更前の公開終了日時
      currentCheckStatus: 'draft', //DBに現在のcheckStatus
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
      visibleCheckStatusOptions: [],
      updatedDataFlag: false,
    };
  },

  validations() {
    return newsAndSeminarValidation.update(this.newsAndSeminarData.checkStatus, this.newsAndSeminarData.transitionType);
  },

  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-news-and-seminars-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-news-and-seminars-edit-' + i;
    }
    this.handleGetNewsAndSeminarInfo();
  },
  mounted() {},
  methods: {
    async handleFormSubmit() {
      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        let errMsg = '';
        this.v$.$errors.map(item => (errMsg += item.$message + '<br>'));
        this.showErrorModal(errMsg);
        return;
      }

      const payload = cloneDeep(this.newsAndSeminarData);
      //  URLに特殊文字　<>'"　を入力するチェックする
      if (messageContent.checkUrlSpecialCharacter(payload.contentsURL)) {
        this.showErrorModal(messageContent.urlSpecialCharater);
        return;
      }
      payload.contentsURL = encodeURI(payload.contentsURL);
      // Note: 「=」はCloudArmorポリシーに抵触するケースがあるためエスケープを行う
      payload.title = payload.title.replace(/=/g, '%%eq%%');

      if (!messageContent.checkHasSpecialCharacterInObj(payload)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }

      const id = this.id;
      if (id) {
        if (this.newsAndSeminarData.castEndDate) {
          const castEndDate = new Date(this.newsAndSeminarData.castEndDate);
          const deleteDate = new Date(castEndDate.setFullYear(castEndDate.getFullYear() + 1));
          this.deleteDate = this.convertDateToString(deleteDate);
        }
        const formDataTmp = {
          id: id ?? '',
          title: payload.title ?? '',
          imageFile: this.newsAndSeminarData.imageFile.binary ?? '',
          importantFlag: this.newsAndSeminarData.importantFlag ?? false,
          castStartDate: this.newsAndSeminarData.castStartDate ?? '',
          castEndDate: this.newsAndSeminarData.castEndDate ?? '',
          deleteDate: this.deleteDate ?? '',
          draftFlag: this.newsAndSeminarData.draftFlag ?? false,
          checkStatus: this.newsAndSeminarData.checkStatus ?? 'draft',
          imageURL: this.newsAndSeminarData.imageURL ?? '',
          type: this.newsAndSeminarData.type ?? '',
          contentsURL: encodeURI(this.newsAndSeminarData.contentsURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
          checkHistories: this.newsAndSeminarData.checkHistories ?? [],
          transitionType: this.newsAndSeminarData.transitionType ?? 'url',
          transitionDoc: this.newsAndSeminarData.transitionDoc ?? '',
        };
        await this.postRequest('/news-and-seminars/edit', formDataTmp).then(res => {
          if (res.status === 'success') {
            this.$router.push({ name: 'NewsAndSeminars', query: { show: this.show } });
          } else {
            if (res.message) {
              this.showErrorModal(res.message);
            } else {
              this.showErrorModal(messageContent.requireTry('おすすめの記事・セミナー更新'));
            }
          }
        });
      } else {
        this.showErrorModal(messageContent.requireTry('おすすめの記事・セミナー更新'));
      }
    },
    handleUploadFileChange(type, file) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          // eslint-disable-next-line no-unused-vars
          const [info, content] = reader.result.split(',');
          vm.newsAndSeminarData[type].binary = content;
        },
        false
      );
      if (file[0]) {
        reader.readAsDataURL(file[0]);
        vm.newsAndSeminarData[type].filename = file[0].name;
        vm.newsAndSeminarData[type].size = file[0].size;
        if (type === 'imageFile' && vm.newsAndSeminarData[type].filename !== null) {
          vm.agree = true;
        }
      } else {
        // clear file content
        vm.newsAndSeminarData[type].file = null;
        vm.newsAndSeminarData[type].filename = null;
        vm.newsAndSeminarData[type].binary = null;
        vm.newsAndSeminarData[type].size = null;
        if (type === 'imageFile' && vm.newsAndSeminarData[type].filename === null) {
          vm.agree = false;
        }
        if (type === 'imageFile') {
          vm.newsAndSeminarData.imageURL = '';
        }
      }
    },
    handleGetNewsAndSeminarInfo() {
      const nowDate = utils.currentDateTime();
      const id = this.$route.query.id;
      if (id) {
        this.postRequest('/news-and-seminars/get', { id })
          .then(e => {
            if (e.status === 'success' && e.data) {
              const data = e.data;
              const authInfo = this.$store.state.user.authInfo;
              if ((authInfo === 'writer' && data.checkStatus === 'draft') || authInfo !== 'writer') {
                this.newsAndSeminarData.title = data?.title || '';
                this.newsAndSeminarData.imageURL = data?.imageURL || '';
                (this.newsAndSeminarData.imageFile = {
                  file: e.data.imageURL ? e.data.imageURL : null,
                }),
                  (this.newsAndSeminarData.importantFlag = data?.importantFlag || false);
                this.newsAndSeminarData.castStartDate = data?.castStartDate || '';
                this.newsAndSeminarData.castEndDate = data?.castEndDate || '';
                this.newsAndSeminarData.contentsURL = decodeURI(data?.contentsURL) || '';
                this.newsAndSeminarData.type = data?.type || '';
                this.newsAndSeminarData.transitionType = data?.transitionType || 'url';
                this.newsAndSeminarData.transitionDoc = data?.transitionDoc || '';
                // 変更前の公開終了日時を保存
                this.beforeCastEndDate = data?.castEndDate || '';
                // 公開中の投稿か確認
                if (
                  data &&
                  data.checkStatus === 'approved' &&
                  data.castStartDate &&
                  data.castEndDate &&
                  data.castStartDate <= nowDate &&
                  nowDate <= data.castEndDate
                ) {
                  this.isPublished = true;
                  this.minDate = '';
                }

                if (this.isPublished) {
                  this.$router.push({ name: 'NewsAndSeminars' });
                  return;
                }

                this.hasParentDoc = data?.parentDocId ? true : false;

                // DBに現在のcheckStatusを保存
                this.currentCheckStatus = data?.checkStatus;
                // 現在のcheckStatusの値しだいでvisibleCheckStatusOptionsを変更する
                this.visibleCheckStatusOptions = this.selectVisibleCheckStatusOptions(data?.checkStatus || '');
                // DBから取得したcheckHistoriesが空配列のときは更新せず、初期値のcampaignData.checkHistoriesを用いる
                if (data?.checkHistories && data?.checkHistories.length > 0) {
                  this.newsAndSeminarData.checkHistories = data?.checkHistories;
                }
              } else {
                this.$router.push({ name: 'PermissionDenied' });
                return;
              }
            } else {
              this.showErrorModal(messageContent.requireTry('おすすめの記事・セミナー取得'));
            }
            this.updatedDataFlag = true;
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('ニュース・セミナー取得'));
          });
      }
    },
    handleCancelClick() {
      const id = this.id;
      const source = this.source;
      if (id && source === 'detail') {
        return this.$router.push({ name: 'NewsAndSeminarsDetail', query: { id: id, show: this.show } });
      } else {
        return this.$router.push({ name: 'NewsAndSeminars', query: { show: this.show } });
      }
    },
    selectVisibleCheckStatusOptions(checkStatus) {
      if (checkStatus === 'draft') {
        return [
          { value: 'draft', label: '下書き' },
          { value: 'checked', label: 'チェック済み' },
        ];
      } else if (checkStatus === 'checked') {
        return [
          { value: 'draft', label: '下書き' },
          { value: 'approved', label: '承認済み' },
        ];
      } else if (checkStatus === 'approved') {
        return [{ value: 'draft', label: '下書き' }];
      }
      // イレギュラーは下書き相当
      return [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
      ];
    },
    backPageName() {
      const source = this.source;
      if (source === 'detail') {
        return '詳細画面';
      } else {
        return '一覧画面';
      }
    },
    backPage() {
      const source = this.source;
      if (source === 'detail') {
        return 'NewsAndSeminarsDetail';
      } else {
        return 'NewsAndSeminars';
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
